import {useEffect, useState, useCallback} from 'react'
import { useAuth } from '../context/AuthContext'

import axios from 'axios'
import "./BusinessGetAndDeleteImages.css"

const BusinessGetAndDeleteImages = ({setDone, done, uploadMessage, currentBusiness}) => {
    const [images, setImages] = useState([])
    const [message, setMessage] = useState(null)
    const {businessToken} = useAuth()




useEffect(() => {
    if (uploadMessage) {
        setMessage(uploadMessage)
    }
}, [uploadMessage])

const fetchImages = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/images/public-images`, {
        params: { businessId: currentBusiness._id }
      });
      setImages(response.data.images);
    } catch (err) {
      setMessage(err.response?.data?.message || "Chyba při načítání obrázků");
    }
  }, [currentBusiness]);

useEffect(() => {
    if (currentBusiness) {
        if (done) {
            fetchImages()
            setDone(false)
            setMessage(null)
        }
        fetchImages()
    }
}, [currentBusiness, setDone, done, fetchImages])

//Smazani obrazku
const handleDelete = async (imageId) => {
if (currentBusiness) {
    try {
        const response = await axios.delete(`${process.env.REACT_APP_API_URL}/images/delete-image/${imageId}`, 
            {data: {businessId: currentBusiness._id},
            headers: {
              Authorization: `Bearer ${businessToken}`
            },
          } 
        );

        console.log(response.data.message);
        
        // Aktualizace stavu po smazání
        setImages(prevImages => prevImages.filter(img => img._id !== imageId));
        setMessage(null)
    } catch (err) {
        setMessage(err.response?.data?.message || "Něco se pokazilo");
    }
  }
};

  return (
    <div>
          <div className='images-container'>
                {images && images.map((image, index) => {
            return (
                <div className='image-wrapper' key={index}>
                    <img src={image.fileUrl} alt="uploaded" />
                    <button className="close-button" onClick={() => handleDelete(image._id)}>×</button>
                </div>
            );
        })}
        
    </div>
    <div>
        {message && <p className='message'> {message}</p>}
      </div>
    </div>

  )
}

export default BusinessGetAndDeleteImages